var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import "./index.scss";
import pubsub from "@viewlift/pubsub";
import React, { forwardRef, useState, useEffect, } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchIcon, CloseIcon, backIcon } from "../../../../images/icon";
import { SearchSuggestionCard } from "../SearchSuggestionCard";
import { NoResultToast } from "../NoResultToast";
import { SEARCH_EVENTS, SEARCH_KEYS } from "../../../types/StandaloneSearchTypes";
import { getPreferredLanguage, handleStatusGaCalls, searchResultData, switchBetweenPages } from "../../../helpers";
import Spinner from "../../../components/HomeLoadingScreen/Spinner";
import { useStandaloneSearchHelper } from "../index";
import { ANALYTICS, FB_EVENTS } from "../../../helpers/analyticsMap";
import { StatsPageRequest } from '../../../Graphql/helper';
import { getVideoRedirectLink } from "../../../components/sliderCore/helpers/getVideoRedirectLink";
import { pushAdobeAnalyticsData } from "../../../AdobeAnalytics/AdobeExtention";
import { removeStorageItem, setStorageItem } from "../../../helpers/storageManager";
export var Searchbox = forwardRef(function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var visible = props.visible, manageVisibility = props.manageVisibility, placeholder = props.placeholder, genericMessages = props.genericMessages;
    var _j = __read(useState(""), 2), searchTerm = _j[0], setSearchTerm = _j[1];
    var _k = __read(useState(undefined), 2), results = _k[0], setResults = _k[1];
    var _l = __read(useState(false), 2), isSearching = _l[0], setIsSearching = _l[1];
    var _m = __read(useState(undefined), 2), searchHistoryData = _m[0], setSearchHistoryData = _m[1];
    var searchConfig = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.searchConfig) !== null && _c !== void 0 ? _c : null;
    var _o = useStandaloneSearchHelper(), clearPreviousSearch = _o.clearPreviousSearch, manageOverlayElement = _o.manageOverlayElement, recentSearchHandler = _o.recentSearchHandler, onItemClickHandler = _o.onItemClickHandler, manageTrayVisibility = _o.manageTrayVisibility, getRecentSearchData = _o.getRecentSearchData;
    var _p = __read(useState(false), 2), isDropdownVisible = _p[0], setIsDropdownVisible = _p[1];
    var _q = __read(useState(false), 2), layoutSettings = _q[0], setLayoutSettings = _q[1];
    var _r = __read(useState({}), 2), fontSetting = _r[0], setFontSetting = _r[1];
    var onSearchTermChange = function (e) {
        var value = e.target.value;
        if (!value) {
            setSearchTerm("");
            recentSearchHandler(SEARCH_EVENTS.DELETE, SEARCH_KEYS.SEARCH_DATA);
            return setResults(undefined);
        }
        handleStatusGaCalls({ eventName: 'logout', subSection: null, type: 'logout', reason: value, status: null, action: 'Search', paymentStatus: null, eventCategory: 'Search', section: null, additionalLabel: null });
        manageOverlayElement([
            { actionType: "show", elementId: "searchResultContainer" },
            { actionType: "show", elementId: "wrapperOverlay" },
        ]);
        pushAdobeAnalyticsData({ eventName: "SEARCH", config: { type: "SEARCH" } });
        return setSearchTerm(value);
    };
    var onSearchSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var searchEventData;
        return __generator(this, function (_a) {
            e.preventDefault();
            if (!searchTerm)
                return [2 /*return*/];
            pubsub.publish("user-analytics", { ename: ANALYTICS.SEARCH, data: { searchText: searchTerm, productDetails: results } });
            pushAdobeAnalyticsData({ eventName: "Page Load", config: { searchKeyword: searchTerm, type: "SEARCH:SEARCH RESULTS" } });
            recentSearchHandler(SEARCH_EVENTS.UPDATE, SEARCH_KEYS.RECENT_SEARCH_TERMS, searchTerm);
            manageOverlayElement([
                { actionType: "hide", elementId: "searchResultContainer" },
                { actionType: "hide", elementId: "wrapperOverlay" },
            ]);
            setIsDropdownVisible(false);
            if (pathname === "/search") {
                removeStorageItem(SEARCH_KEYS.SEARCH_DATA);
                pubsub.publish(SEARCH_KEYS.SEARCH_DATA, JSON.stringify(results));
                pubsub.publish(SEARCH_KEYS.LATEST_SEARCH_WORD, searchTerm);
            }
            else {
                switchBetweenPages();
                setStorageItem(SEARCH_KEYS.SEARCH_DATA, { word: searchTerm, data: results });
                pubsub.publish(SEARCH_KEYS.LATEST_SEARCH_WORD, searchTerm);
                navigate("/search", { state: { searchTerm: searchTerm } });
            }
            searchEventData = {
                keyword: searchTerm,
                platform: 'Web'
            };
            pubsub.publish("FB-analytics", { eventType: FB_EVENTS.SEARCH, payload: searchEventData, type: 'FB' });
            return [2 /*return*/];
        });
    }); };
    var clearTextbox = function () {
        setSearchTerm("");
        // setIsDropdownVisible(false);
        // recentSearchHandler(SEARCH_EVENTS.DELETE, SEARCH_KEYS.SEARCH_DATA);
    };
    var manageSearchOverlay = function () {
        setIsDropdownVisible(false);
        manageOverlayElement([
            { actionType: "hide", elementId: "searchResultContainer" },
            { actionType: "hide", elementId: "wrapperOverlay" },
        ]);
        setSearchTerm("");
        setIsDropdownVisible(false);
        // recentSearchHandler(SEARCH_EVENTS.DELETE, SEARCH_KEYS.SEARCH_DATA);
        if (props === null || props === void 0 ? void 0 : props.showSearchbar) {
            manageVisibility(true);
        }
        else {
            manageVisibility(false);
        }
    };
    var ComposedResultList = function () {
        var _a, _b, _c;
        // setIsDropdownVisible(true)
        if (isSearching)
            return React.createElement(Spinner, { type: "plain" });
        if (!results)
            return React.createElement("li", null, (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.noResultForLabel) || "No Data Available");
        if (!((_b = (_a = results === null || results === void 0 ? void 0 : results.search) === null || _a === void 0 ? void 0 : _a.records) === null || _b === void 0 ? void 0 : _b.length)) {
            var messageText = (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.noResultForLabel) ? "".concat(genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.noResultForLabel, " ").concat(searchTerm) : '';
            return React.createElement(NoResultToast, { messageText: messageText || "There are no results for your search" });
        }
        return (React.createElement(React.Fragment, null, (_c = results === null || results === void 0 ? void 0 : results.search) === null || _c === void 0 ? void 0 : _c.records.slice(0, 5).map(function (node) { return (React.createElement(SearchSuggestionCard, { id: "result-suggestion-card", key: node.gist.id, data: __assign({}, node), style: { paddingRight: "0px", cursor: "pointer" }, onClick: function () {
                if (pathname === node.gist.permalink) {
                    return manageOverlayElement([
                        { actionType: "hide", elementId: "searchResultContainer" },
                        { actionType: "hide", elementId: "wrapperOverlay" },
                    ]);
                }
                onItemClickHandler({ clickedNode: node, url: node.gist.permalink });
                switchBetweenPages();
                // navigate({ pathname: node.gist.permalink });
            }, onKeyDown: function (e) {
                if (e.key === "Enter") {
                    if (pathname === node.gist.permalink) {
                        return manageOverlayElement([
                            { actionType: "hide", elementId: "searchResultContainer" },
                            { actionType: "hide", elementId: "wrapperOverlay" },
                        ]);
                    }
                    onItemClickHandler({ clickedNode: node, url: node.gist.permalink });
                    switchBetweenPages();
                }
            }, layoutSettings: layoutSettings, fontSetting: fontSetting })); })));
    };
    var RecentSearchList = function () {
        var _a, _b, _c;
        if (!((_b = (_a = searchHistoryData === null || searchHistoryData === void 0 ? void 0 : searchHistoryData.search) === null || _a === void 0 ? void 0 : _a.records) === null || _b === void 0 ? void 0 : _b.length))
            return null;
        return (React.createElement("div", { className: "vl_recent_search" },
            React.createElement("div", { className: "vl_recent_search_header" },
                React.createElement("h3", null, (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.kRecentSearchTitle) || "Recent Searches"),
                React.createElement("p", { role: "button", onKeyDown: function (e) {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            clearPreviousSearch(SEARCH_KEYS.RECENT_SEARCH_TERMS);
                        }
                    }, onClick: function () { return clearPreviousSearch(SEARCH_KEYS.RECENT_SEARCH_TERMS); } }, (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.clearHistoryCta) || "Clear History")),
            React.createElement("ul", { className: "vl_recent_search_results" }, __spreadArray([], __read(new Set((_c = searchHistoryData === null || searchHistoryData === void 0 ? void 0 : searchHistoryData.search) === null || _c === void 0 ? void 0 : _c.records)), false).map(function (item) {
                var _a;
                return (React.createElement("li", { id: "vl_recent_search_result", title: (_a = item.gist.title) !== null && _a !== void 0 ? _a : "", className: "vl_recent_search_result", key: "".concat(item, "_").concat(Date.now()), onKeyDown: function (e) {
                        var _a, _b;
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            var url = getVideoRedirectLink(item) || ((_b = (_a = item === null || item === void 0 ? void 0 : item.gist) === null || _a === void 0 ? void 0 : _a.permalink) !== null && _b !== void 0 ? _b : "");
                            switchBetweenPages();
                            navigate(url);
                        }
                    }, onClick: function () {
                        var _a, _b;
                        var url = getVideoRedirectLink(item) || ((_b = (_a = item === null || item === void 0 ? void 0 : item.gist) === null || _a === void 0 ? void 0 : _a.permalink) !== null && _b !== void 0 ? _b : "");
                        switchBetweenPages();
                        navigate(url);
                    } }, item.gist.title));
            }))));
    };
    var SearchSuggestionList = function () {
        var _a, _b, _c, _d;
        if (isSearching)
            return null;
        if (!((_b = (_a = results === null || results === void 0 ? void 0 : results.search) === null || _a === void 0 ? void 0 : _a.related) === null || _b === void 0 ? void 0 : _b.length))
            return null;
        return (React.createElement("div", { className: "vl_recent_search", id: "vl_recent_search" },
            React.createElement("div", { className: "vl_recent_search_header" },
                React.createElement("h3", null,
                    " ",
                    (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.kSearchTitlesRelated) || "Search titles related to: ")),
            React.createElement("ul", { className: "vl_recent_search_results" }, (_d = (_c = results === null || results === void 0 ? void 0 : results.search) === null || _c === void 0 ? void 0 : _c.related) === null || _d === void 0 ? void 0 : _d.slice(0, 10).map(function (item) { return (React.createElement("li", { id: "vl_recent_search_result", className: "vl_recent_search_result", key: "".concat(item, "_").concat(Date.now()), onKeyDown: function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setSearchTerm(item.gist.title);
                    }
                }, onClick: function () { return setSearchTerm(item.gist.title); } }, item.gist.title)); }))));
    };
    useEffect(function () {
        if (pathname.includes("/search"))
            manageVisibility(true);
        return function () { };
    }, [pathname]);
    useEffect(function () {
        if (!searchTerm)
            return manageTrayVisibility("vl_search_tray_row", "block");
        setIsSearching(true);
        setIsDropdownVisible(true);
        var debounce = setTimeout(function () {
            var _a, _b, _c;
            var languageCode = getPreferredLanguage();
            var countryCode = ((_a = window.app_data) === null || _a === void 0 ? void 0 : _a.countryCode) || "IN";
            var variables = {
                "site": (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.site) === null || _c === void 0 ? void 0 : _c.siteInternalName,
                "path": '/search',
                "device": "WEB",
                "includeContent": true,
                "languageCode": languageCode,
                "countryCode": countryCode
            };
            StatsPageRequest(variables).then(function (data) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var modulesData = ((_a = data === null || data === void 0 ? void 0 : data.page) === null || _a === void 0 ? void 0 : _a.modules) || null;
                var getSearchLayout = modulesData === null || modulesData === void 0 ? void 0 : modulesData.filter(function (moduleData) { return (moduleData === null || moduleData === void 0 ? void 0 : moduleData.moduleType) === 'SearchModule'; });
                var searchContentType = (getSearchLayout && ((_d = (_c = (_b = getSearchLayout[0]) === null || _b === void 0 ? void 0 : _b.layout) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d.types)) || [];
                var layoutSettings = (getSearchLayout && ((_f = (_e = getSearchLayout[0]) === null || _e === void 0 ? void 0 : _e.layout) === null || _f === void 0 ? void 0 : _f.settings));
                var fontSetting = (getSearchLayout && ((_h = (_g = getSearchLayout[0]) === null || _g === void 0 ? void 0 : _g.layout) === null || _h === void 0 ? void 0 : _h.fontSetting));
                setLayoutSettings(layoutSettings);
                setFontSetting(fontSetting);
                searchResultData({ key: searchTerm, type: searchContentType })
                    .then(function (resData) {
                    setResults({ search: resData });
                    pubsub.publish(SEARCH_KEYS.LATEST_SEARCH_WORD, searchTerm);
                })
                    .finally(function () { return setIsSearching(false); });
            });
        }, 500);
        return function () {
            setIsSearching(false);
            setResults(undefined);
            clearTimeout(debounce);
            setIsDropdownVisible(false);
        };
    }, [searchTerm]);
    useEffect(function () {
        getRecentSearchData()
            .then(function (recentData) {
            var _a;
            if (!recentData || ((_a = recentData === null || recentData === void 0 ? void 0 : recentData.items) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                setSearchHistoryData(undefined);
            }
            else
                setSearchHistoryData({ search: { records: recentData.items }, type: "recent" });
        })
            .catch(console.error);
        return function () { };
    }, []);
    if (!(searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.isEnabled))
        return null;
    return visible ? (React.createElement(React.Fragment, null,
        searchTerm.length ? (React.createElement("div", { className: "vl_searchbox_wrapper_overlay", id: "wrapperOverlay", onKeyDown: function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    manageSearchOverlay;
                }
            }, onClick: manageSearchOverlay })) : null,
        React.createElement("div", { id: "vl_searchbox_wrapper", className: "vl_searchbox_wrapper", style: { borderRadius: isDropdownVisible === true ? "8px 8px 0px 0px" : "8px" } },
            React.createElement("span", { tabIndex: 0, "aria-label": "Go back to previous page button", role: "button", onKeyDown: function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        switchBetweenPages();
                        navigate(-1);
                    }
                }, onClick: function () {
                    switchBetweenPages();
                    navigate(-1);
                }, id: "search-back-icon" }, backIcon()),
            React.createElement("form", { onSubmit: onSearchSubmit, id: "vl_searchbox_form_wrapper", className: "vl_searchbox_form_wrapper" },
                React.createElement(SearchIcon, { id: "searchIcon", "aria-labelledby": "Search", className: "vl_searchbox_icon_search", onKeyDown: function (e) {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            manageVisibility(false);
                        }
                    }, onClick: function () { return manageVisibility(false); } }),
                React.createElement("input", { "aria-labelledby": placeholder, autoFocus: true, id: "vl_searchbox_input", className: "vl_searchbox_input", ref: ref, type: "text", placeholder: placeholder, value: searchTerm, autoComplete: "off", onChange: onSearchTermChange }),
                searchTerm ? (React.createElement(CloseIcon, { className: "vl_searchbox_icon_close", "aria-labelledby": "Close", fill: "#000", tabIndex: 0, onClick: function (e) {
                        clearTextbox(e);
                        // manageVisibility(false);
                    }, onKeyDown: function (e) {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            clearTextbox(e);
                        }
                    } })) : null,
                searchTerm ? (React.createElement("div", { id: "searchResultContainer", className: "vl_search_result_container" },
                    React.createElement("div", { className: "vl_search_result_list" },
                        React.createElement(ComposedResultList, null),
                        !((_e = (_d = results === null || results === void 0 ? void 0 : results.search) === null || _d === void 0 ? void 0 : _d.records) === null || _e === void 0 ? void 0 : _e.length) ? null : (React.createElement("button", { onBlur: function () {
                                clearTextbox({});
                                manageVisibility(false);
                            }, tabIndex: 0, id: "vl_search_result_button", "aria-label": "search submit", className: "vl_search_result_button", type: "submit" }, "".concat(((_h = (_g = (_f = window === null || window === void 0 ? void 0 : window.app_data) === null || _f === void 0 ? void 0 : _f.appcmsMain) === null || _g === void 0 ? void 0 : _g.genericMessages) === null || _h === void 0 ? void 0 : _h.seeSearchResultText) || "See results for", " \"").concat(searchTerm, "\""))),
                        React.createElement(RecentSearchList, null),
                        React.createElement(SearchSuggestionList, null)))) : null)))) : (React.createElement(SearchIcon, { id: "searchIcon", style: { cursor: "pointer" }, onKeyDown: function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                manageVisibility(true);
            }
        }, onClick: function () { return manageVisibility(true); } }));
});
Searchbox.displayName = "Searchbox";
